import { render, staticRenderFns } from "./privatetalk.vue?vue&type=template&id=5dfd6db4&scoped=true"
import script from "./privatetalk.vue?vue&type=script&lang=js"
export * from "./privatetalk.vue?vue&type=script&lang=js"
import style0 from "./privatetalk.vue?vue&type=style&index=0&id=5dfd6db4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfd6db4",
  null
  
)

export default component.exports